import {createRouter, createWebHistory} from "vue-router";
import help from "../assets/js/help";
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/index"),
    meta: {
      title: "每日抢积分 邀请送豪礼",
    },
  },
  {
    path: "/router",
    name: "router",
    component: () => import("../views/router.vue"),
    meta: {
      title: "路由",
    },
  },
  {
    path: "/index",
    name: "spring",
    component: () => import("../views/index"),
    meta: {
      title: "",
    },
  },
  {
    path: "/address",
    name: "Address",
    component: () => import("../components/AddressEditor"),
    meta: {
      title: "更新地址 - 第一电动",
    },
  },
];
const router = createRouter({
  history: createWebHistory("/spring/"),
  routes
});
router.beforeEach(async (to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["_trackPageview", to.href]);
    }
  }
  if (process.env.NODE_ENV === "production") {
    if (!window.d1ev && !window.webkit) {
      window.location.href = "https://www.d1ev.com/special/spring-activity/share.html";
      //window.location.href = "https://www.d1ev.com/special/spring-activity/share-test.html";
    }
    if (!topBarHeight) {
      restTopBar();
    }
    resetBarMode(to.href);
    next();
  } else {
    next();
  }
});
export default router;
